module.exports = __webpack_public_path__ + "static/img/twjd-sds1.ac4b99f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/twjd-sds1.png
// module id = 870
// module chunks = 0